/*
    Strips out the necessary data, and allows us to order by products based on location in product list
*/
const prepareTopPicksData = (topPicks) => {
    let prodList = window.bf20.topPicks;
    const preparedData = [];

    if (window.bf20.previewMode) {
        prodList = window.bf20.topPicksPreview;
    }

    for (let i = 0; i < prodList.length; i++) {
        for (let j = 0; j < topPicks.length; j++) {
            if (prodList[i] === topPicks[j].identification.prdNumber) {
                const topPickItem = {};                
                topPickItem.brand = topPicks[j].name.brand;
                topPickItem.title = topPicks[j].name.title;
                topPickItem.wasPrice = topPicks[j].price.wasFrom;
                topPickItem.nowPrice = topPicks[j].price.nowFrom;
                topPickItem.img = topPicks[j].images[0].src;
                topPickItem.url = topPicks[j].identification.prdNumber;
                topPickItem.ratings = topPicks[j].reviews.stars;
                topPickItem.itemCode = topPicks[j].identification.itemNumber;                
                preparedData.push(topPickItem);
            }
        }
    }

    return preparedData;
}

const getStarsWidth = reviewStars => {
    return 100 / 5 * parseFloat(reviewStars);
};

const getImageHeight = () => {
    const placeHolderImage = document.querySelector('#topPicks .placeHolderImage');
    if (placeHolderImage) {
        return placeHolderImage.offsetHeight;
    }
    return false;
}

const generateHTML = (topPicksInfo) => {
    const topPicksData = prepareTopPicksData(topPicksInfo);
    let markup = '';
    
    function getPrice(price) {        
        return `<span class="topPick__wasPrice">${window.bf20.currencySymbol}${price}</span>`;
    }

    function getReviews(ratings, starsWidth) {
        return  `<div class="topPick__review">
                        <span class="reviewStars">
                        <span class="reviewStarColour" style="width: ${starsWidth}%"></span>
                        <span class="starMask">
                            <svg width="77" height="21" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 199.8"><path d="M0 0v199.8h1024V0H0zm165.4 194.9l-60.2-49.4-57.9 49.4 22.9-74.8L9.9 80.5h74l21-75.6 21 75.6h74L140 120.2l25.4 74.7zm202.9 0l-60.2-49.4-57.9 49.4 22.9-74.8-60.2-39.6h74l21-75.6 21 75.6h74L343 120.2l25.3 74.7zm203 0L511 145.5l-57.9 49.4 22.9-74.8-60.2-39.6h74l21-75.6 21 75.6h74l-59.9 39.6 25.4 74.8zm202.9 0L714 145.5l-57.9 49.4 22.9-74.8-60.2-39.6h74l21-75.6 21 75.6h74l-59.9 39.6 25.3 74.8zm202.9 0l-60.2-49.4-57.9 49.4 22.9-74.8-60.2-39.6h74l21-75.6 21 75.6h74l-59.9 39.6 25.3 74.8z" fill="#fff"></path></svg>
                        </span>
                        </span>
                        <span class="topPick_reviewRating">(${parseFloat(ratings).toFixed(1)})</span>
                    </div>`
    }

    topPicksData.forEach(product => {        
        const starsWidth = getStarsWidth(product.ratings);
        const imagePath = `https://media.very.co.uk/i/very/${product.img}/?$120x160_retinamobilex2$`;
        const url = `/${product.url}.prd`;
        let wasPrice = '';
        let reviewStars = '';

         // Was price
        if (product.wasPrice) {
            wasPrice += getPrice(product.wasPrice);
        }

        // Ratings 
        if (product.ratings) {
            reviewStars = getReviews(product.ratings, starsWidth);
        }        

        markup += `<a class="topPick banner" data-item-code="${product.itemCode}" href="${url}">
                    <div class="topPick__imageWrap">
                        <img class="topPick__img" src="${imagePath}" height="${getImageHeight()}">
                    </div>
                    <div class="topPick__detailsWrap">
                        <div class="topPick__brand">${product.brand}</div>
                        <div class="topPick__title">${product.title}</div>
                        <div class="topPick__prices">
                        ${wasPrice}
                        <span class="topPick__nowPrice">${window.bf20.currencySymbol}${product.nowPrice}</span>
                        </div>
                        ${reviewStars}
                    </div>                    
                </a>
                `
    })
    
    return markup;
}

export default generateHTML;